
  import Vue from "vue";
  import FooterText from "@/components/common/FooterText.vue";
  import HostedRegistrationPayment from "@/components/common/HostedRegistrationPayment.vue";
  import DogRegistrationFeeTable from "@/components/Portal/DogRegistrationFeeTable.vue";
  export default Vue.extend({
    name: "SummaryPayment",
    components: { FooterText, HostedRegistrationPayment, DogRegistrationFeeTable },
    props: {
      changePage: Function,
      submit: Function,
      price: Number,
      priceInfo: Array,
    },
    data: function () {
      return {}
    },
  });
  